module.exports = __webpack_public_path__ + "img/7.16d8f941.svg";